export enum NotificationTypes {
  Release = 1,
  Text = 2
}
